
















import { Component, Prop, Vue } from "vue-property-decorator";
import Scoring from "../../store/modules/Scoring";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import ScoreSliderKey from "@/components/scoring-input/ScoreSliderKey.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import { Viewpoint } from "@/api/model/Viewpoint";

const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users)
const scoringModule = getModule(Scoring)
const scoringKeyModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions)

@Component({components: {ScoringSliderSelect: ScoreSliderKey}})
export default class ViewpointChoiceScore extends Vue {

    @Prop()
    viewpoint!: Viewpoint;

    @Prop()
    choiceId!: string;

    @Prop({default: (() => true)})
    displayScoringKey!: boolean;

    get isOwner() {
        return usersModule.currentUserProfile && this.viewpoint.ownerUserId === usersModule.currentUserProfile.userId
    }

    get invalidatedStatus() {
        return scoringModule.invalidatedViewpointScoring[this.viewpoint.viewpointId];

    }

    get choiceScoreData() {
        if (scoringModule.viewpointScores[this.viewpoint.viewpointId]
            && scoringModule.viewpointScores[this.viewpoint.viewpointId].choiceScores) {
            return scoringModule.viewpointScores[this.viewpoint.viewpointId].choiceScores[this.choiceId]
        }
    }

    get score() {
        if (!this.choiceScoreData) return null;
        return this.choiceScoreData.choiceFactorScores['M'].score;
    }

    get displayScoreBar() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get scoringKey() {
        if (!this.displayScoringKey) return null;
        if (scoringKeyModule.viewpointScoringKeyDefinitions &&
            scoringKeyModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]
            && scoringKeyModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]['M']) {
            //@ts-ignore
            return scoringKeyModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]['M'].scoringKeys || []
        }
        return [];
    }


}
